<template>
  <div v-loading="state.loading">
    <page-title>
      <el-button type="primary" @click="onSubmit">Переместить</el-button>
    </page-title>

    <el-form labelPosition="top">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item label="Откуда">
            <el-select
              size="small"
              :disabled="isHookahMaker"
              placeholder="Откуда"
              v-model="fromPlace"
              @change="onStorageFromChange"
            >
              <el-option
                v-for="place in storagesFrom"
                :key="place.id"
                :value="place.id"
                :label="place.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Куда">
            <el-select
              size="small"
              :disabled="isHookahMaker"
              placeholder="Куда"
              v-model="toPlace"
              @change="clearArray"
            >
              <el-option
                v-for="place in filteredStoragesTo"
                :key="place.id"
                :value="place.id"
                :label="place.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :offset="2">
          <el-form-item label="Выбранные товары" v-if="selectedProducts.length">
            <el-radio-group size="mini" v-model="state.moveType">
              <el-radio-button label="left">Сколько осталось</el-radio-button>
              <el-radio-button label="spend">Сколько списать</el-radio-button>'
            </el-radio-group>
            <el-table :data="selectedProducts" size="mini">
              <el-table-column label="Наименование" prop="name"></el-table-column>
              <el-table-column label="Кол-во">
                <template slot-scope="props">
                  <el-input
                    @keyup.native="validateNum(props.row)"
                    v-model="props.row.addCount"
                    size="mini"
                    :min="1"
                    :max="props.row.maxcount"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right">
                <template slot-scope="scope">
                  <i class="el-icon-delete cursor_pointer" @click="removeItem(scope.$index)"></i>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
      <hr />
      <br />
      <el-row v-show="fromPlace && toPlace">
        <el-col :span="18">
          <data-tree
            :data="categoriesTree"
            :filtration="true"
            filterProp="name"
            node-key="id"
            :defaultExpandedKeys="defaultExpanded"
            :auto-expand-parent="true"
          >
            <template slot="row" slot-scope="{node, data}">
              <div>
                <div class="products-report__tree__name">
                  <div v-if="!data.isProduct">{{data.name}}</div>
                  <div v-if="data.isProduct">
                    <el-checkbox
                      style="margin-bottom: 0;"
                      v-model="state.selectedProductsMap[data.id]"
                      @change="(val) => onProductSelect(data, val)"
                    >{{data.name}}</el-checkbox>

                    <span
                      v-if="fromPlace && data.storages[fromPlace]"
                      style="float: right; margin-left: 40px;"
                    >Осталось в '{{data.storages[fromPlace].name}}': {{data.storages[fromPlace].count}} шт.</span>
                  </div>
                </div>
              </div>
            </template>
          </data-tree>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  getGoodStorages,
  getCategories,
  getGoods,
  getPlaces,
  postGoodsMove
} from "@/modules/productsStorage/api";
import { findIndex } from "lodash";
import { mapTree } from "@/utils/products";
import { getProducts } from "@/modules/products/api";
import mapStoragesToProducts from "../../services/mapStorageToProducts";

import _ from "lodash";

export default {
  name: "move_goods",
  data() {
    return {
      state: {
        loading: true,
        selectedProductsMap: {},
        moveType: "left",
        filterText: ""
      },
      storagesFrom: [],
      storagesTo: [],
      categoriesTree: [],
      categories: [],
      fromPlace: null,
      toPlace: null,
      selectedProducts: [],
      defaultExpanded: [],
      tobacco: [],
      maxProductfromPlace: null
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    filteredStoragesTo() {
      return this.storagesTo.filter(storage => {
        return storage.id !== this.fromPlace;
      });
    },
    isHookahMaker() {
      return this.$store.getters.roles.includes("ROLE_HOOKAH");
    }
  },
  methods: {
    loadData() {
      Promise.all([
        getCategories(),
        getGoodStorages(),
        getProducts(),
        getPlaces()
      ]).then(response => {
        this.categories = response[0].data.items;
        this.storageToProducts = _.get(response[1].data, "items", []);
        this.products = response[2].data.items;
        this.storages = response[3].data.items;

        this.storagesFrom = this.storages.filter(storage => !storage.spending);
        this.storagesTo = this.storages;

        if (this.isHookahMaker) {
          this.fromPlace = _.get(
            this.storages.find(({ name }) => name === "Бар"),
            "id",
            null
          );
          this.toPlace = _.get(
            this.storages.find(({ name }) => name === "Реализация"),
            "id",
            null
          );

          this.products = this.products.filter(product =>
            product.properties.some(
              item =>
                item.property.mobile_type === "is_tobacco" &&
                item.value === "true"
            )
          );

          mapStoragesToProducts(
            this.products,
            this.storages,
            this.storageToProducts
          );

          this.defaultExpanded = this.products.map(({ id }) => id);

          this.categoriesTree = mapTree(this.categories, this.products).filter(
            item => {
              return this.checkCategoryProducts(item);
            }
          );
        } else {
          mapStoragesToProducts(
            this.products,
            this.storages,
            this.storageToProducts
          );

          this.categoriesTree = mapTree(this.categories, this.products);

          this.categoriesTree.forEach(cat => {
            this.defaultExpanded.push(cat.id);
          });
        }

        this.state.loading = false;
      });
    },
    checkCategoryProducts(item) {
      if (item.isProduct) {
        return true;
      }

      if (!item.children || !item.children.length) {
        return false;
      }

      item.children = item.children.filter(child => {
        return this.checkCategoryProducts(child);
      });

      return item.children.length;
    },

    onProductSelect(product, val) {
      if (val && this.fromPlace !== null) {
        this.selectedProducts.push({
          ...product,
          addCount: 0,
          maxcount: product.storages[this.fromPlace].count
        });
      } else if (val) {
        this.selectedProducts.push({ ...product, addCount: 0 });
      } else {
        let index = this.selectedProducts.findIndex(
          selectedProduct => product.id === selectedProduct.id
        );
        this.selectedProducts.splice(index, 1);
      }
    },
    validateNum(product) {
      let value = product.addCount;
      let validate = /[^0-9]/g;

      if (validate.test(value)) {
        value = value.replace(validate, "");
        product.addCount = value;
      }

      if (+product.addCount > +product.maxcount) {
        this.$message.error("Превышенно количество товара");
        product.addCount = product.maxcount;
        return false;
      } else {
        return true;
      }
    },
    removeItem(index) {
      this.state.selectedProductsMap[this.selectedProducts[index].id] = false;
      this.selectedProducts.splice(index, 1);
    },
    onStorageFromChange() {
      this.clearArray();
      if (this.fromPlace === this.toPlace) {
        this.toPlace = null;
      }
    },
    clearArray() {
      this.selectedProducts.forEach(product => {
        this.state.selectedProductsMap[product.id] = false;
      });
      this.selectedProducts = [];
      this.$forceUpdate();
    },
    checkCountByZero(params) {
      let zeroInCount = false;
      params.products.forEach(item => {
        if (item.count == 0) zeroInCount = true;
      });
      return zeroInCount;
    },
    onSubmit() {
      if (!this.fromPlace || !this.toPlace) {
        this.$message.error("Выберите направление перемещения");
        return;
      }

      if (!this.selectedProducts.length) {
        this.$message.error("Нет выбранных товаров");
        return;
      }

      let products = this.selectedProducts.map(item => ({
        count: "" + item.addCount,
        id: item.id
      }));

      let params = {
        toStorage: this.toPlace,
        fromStorage: this.fromPlace,
        products
      };

      if (this.state.moveType === "left") {
        params.remainder = true;
      }

      if (this.state.moveType === "spend" && this.checkCountByZero(params)) {
        this.$message.error("Нельзя перемещать нуль товаров");
        return;
      }
      this.state.loading = true;

      postGoodsMove(params)
        .then(response => {
          this.state.loading = false;
          this.$message.success("Товары перемещены");
          if (!this.isHookahMaker) {
            this.$router.push({ name: "StorageGoods.main" });
          } else {
            this.selectedProducts.forEach(({ id }) => {
              this.state.selectedProductsMap[id] = false;
            });
            this.selectedProducts = [];

            this.state.loading = true;

            getGoodStorages().then(response => {
              this.storageToProducts = _.get(response.data, "items", []);
              mapStoragesToProducts(
                this.products,
                this.storages,
                this.storageToProducts
              );

              this.categoriesTree = mapTree(
                this.categories,
                this.products
              ).filter(item => {
                return this.checkCategoryProducts(item);
              });

              this.state.loading = false;
              this.$forceUpdate();
            });
          }
        })
        .catch(error => {
          this.state.loading = false;
          this.$message.error("Ошибка при перемещнии товаров");
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/modules/productsStorage/components/storageAndGoods/moveGoods.vue